import { render, staticRenderFns } from "./TransferirNotasModal.vue?vue&type=template&id=e4ec77ae"
import script from "./TransferirNotasModal.vue?vue&type=script&lang=js"
export * from "./TransferirNotasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports